module.exports = __webpack_public_path__ + "static/KL-2741f871dbd35df7e23c2bc5872d2189.png";